import { render } from "./BookingAsideDefault.vue?vue&type=template&id=0bdd9d12"
import script from "./BookingAsideDefault.vue?vue&type=script&lang=js"
export * from "./BookingAsideDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingAsideStates/BookingAsideDefault.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bdd9d12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bdd9d12', __exports__)) {
    api.reload('0bdd9d12', __exports__)
  }
  
  module.hot.accept("./BookingAsideDefault.vue?vue&type=template&id=0bdd9d12", () => {
    api.rerender('0bdd9d12', render)
  })

}


export default __exports__